
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 11 11","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.32.388c.267.11.44.37.44.66v8.571a.714.714 0 01-1.219.505L2.893 7.476H1.046a.714.714 0 01-.714-.714V3.905c0-.395.32-.714.714-.714h1.847L5.541.543A.714.714 0 016.32.388zM7.163 3.83a.556.556 0 01.785 0l.719.718.718-.718a.556.556 0 11.786.785l-.719.719.719.718a.555.555 0 11-.786.786l-.718-.719-.719.719a.556.556 0 01-.785-.786l.718-.718-.718-.719a.556.556 0 010-.785z"}})])
          )
        }
      }
    